import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Section, Heading, EmptyState } from "../components/Bits";
import { Heart, BookOpen, LogOut } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth() || {};
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/"); };

  if (!user) {
    return (
      <Section>
        <EmptyState title="Bitte anmelden">
          <Link to="/login" className="btn-primary">Login</Link>
        </EmptyState>
      </Section>
    );
  }

  return (
    <Section>
      <Heading overline="Profil" title={`Moien ${user.name}!`} subtitle={user.email} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="profile-grid">
        <Link to="/favorites" className="plant-card p-6 flex items-start gap-4">
          <Heart className="w-6 h-6" style={{ color: "var(--wp-primary)" }} />
          <div><div className="font-display text-lg">Merkliste</div><div className="text-xs opacity-70">Deine gespeicherten Pflanzen</div></div>
        </Link>
        <Link to="/journal" className="plant-card p-6 flex items-start gap-4">
          <BookOpen className="w-6 h-6" style={{ color: "var(--wp-primary)" }} />
          <div><div className="font-display text-lg">Tagebuch</div><div className="text-xs opacity-70">Deine Funde</div></div>
        </Link>
        <button onClick={handleLogout} className="plant-card p-6 flex items-start gap-4 text-left" data-testid="profile-logout">
          <LogOut className="w-6 h-6" style={{ color: "var(--wp-toxic)" }} />
          <div><div className="font-display text-lg">Abmelden</div><div className="text-xs opacity-70">Bis bald!</div></div>
        </button>
      </div>
    </Section>
  );
}
